import {
    OnChanges,
    AfterContentInit,
    Directive,
    ElementRef,
    HostListener,
    Input,
    OnInit,
    Renderer2,
  } from '@angular/core';
  
  @Directive({ selector: '[changeFont]' })
  export class ChangeFont implements OnChanges {
    @Input() fontSizeFactorValue: any;
    @Input() fontSizeFactor: any;
    actualHeight;
    visibleHeight;
    constructor(private el: ElementRef) {}
    ngOnChanges(): void {
      //calculate line height
      const fontSize = + window.getComputedStyle(this.el.nativeElement, null).getPropertyValue('font-size').replace("px", "");
      if(this.fontSizeFactor.operation == 'add'){
        (this.el.nativeElement as HTMLParagraphElement).style.fontSize = `${fontSize + 2}px`;

      }
  
      
      if(this.fontSizeFactor.operation == 'min'){
        
        (this.el.nativeElement as HTMLParagraphElement).style.fontSize = `${fontSize - 2}px`;

      }
    }  
  }
  